import React, { PureComponent, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { Build, Business, PinDrop } from '@material-ui/icons';
import { Grid } from '@material-ui/core';
import WifiIcon from '@material-ui/icons/Wifi';
import StarIcon from '@material-ui/icons/Star';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import { green } from '@material-ui/core/colors';
import iconsInfo from '../../assets/images/iconsInfo.svg';
import iconsLocation from '../../assets/images/iconsLocation.svg'

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    borderRadius: 30,
    height: '500px',
    overflow: 'auto',
  },
  textInfo: {
    color: '#000',
    fontFamily: 'Inter',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '110%',
    letterSpacing: '-0.2px',
  },
  textLocation: {
    color: '#000',
    fontFamily: 'Inter',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    letterSpacing: '-0.16px',
  },
  textSubText: {
    color: '#000',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 300,
    lineHeight: 'normal',
    letterSpacing: '-0.14px',
  },
  textButton: {
    zIndex: 1500,
    position: 'absolute',
    right: '15px',
    bottom: '-3px',
    color: '#595959',
    fontFamily: 'Inter',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '130%',
    textDecorationLine: 'underline',
    cursor: 'pointer',
  },
});

const MoCards = React.memo(({ data }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };
  const classes = useStyles();
  return data.map((item, i) => (
    <Grid item lg={4} sm={2} xs={12}>
      <Card className={classes.root}>
        <Link to={`/mop/review/${item.P_ID}`}>
          <CardActionArea style={{ height: 'auto' }}>
            <CardMedia
              component="img"
              title={item.P1}
              style={{
                height: '15rem',
                objectFit: 'cover',
                borderRadius: 30,
              }}
              src={`/mop/images/${item.C_FILE}`}
            />
            <CardContent style={{ height: '10rem', padding: 8 }}>
              <Grid
                container
                  // direction="column"
                spacing={2}
                justifyContent="space-evenly"
                alignItems="flex-start "
              >
                <Grid item xs={12}>
                  <Grid container direction="row" alignItems="center" style={{ textAlign: 'left' }}>
                    <Grid item xs={2}>
                    <img className={classes.icon} src={iconsInfo} />
                      {/* <Business style={{ color: 'black' }} /> */}
                    </Grid>
                    <Grid item xs={10}>
                      <Typography
                        variant="caption"
                        // color="textPrimary"
                        // style={{fontSize: '20px',}}
                        className={classes.textInfo}
                      >
                      {item.P1}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid
                    container
                    direction="row"
                      // alignItems="center"
                      // spacing={3}
                    style={{ textAlign: 'left' }}
                  >
                    <Grid item xs={2}>
                    <img className={classes.icon} src={iconsLocation} />
                      {/* <LocationOnIcon style={{ color: 'black' }} /> */}
                    </Grid>
                    <Grid item xs={10}>
                      <Typography
                        variant="body2"
                        // color="textSecondary"
                        component="span"
                        gutterBottom
                        className={classes.textLocation}
                      >
                        {item.P5}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{margin:'0 0 15px 15px'}}>
                     <Typography
                      variant="body2"
                      component="span"
                      gutterBottom
                      className={classes.textSubText}
                    >
                      {item.P19}
                    </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </CardActionArea>
        </Link>
      </Card>
    </Grid>
  ));
});

export default withRouter(MoCards);

// <div className="card card-block " style={{width:"400px"}} key={item.P_ID}>
//   <img className="card-img-top" src={item.C_FILE} alt="Card image" />
//   <div className="card-body">
//     <h4 className="card-title">{item.P1}</h4>
//     <p className="card-text">Місто: {item.P5}</p>
//     <p className="card-text">Тип закладу: {item.P19}</p>

//     <Button
//       variant="contained"
//       onClick={e => this.props.history.push(`/review/${item.P_ID}`)}
//     >
//       Детальніше...
//     </Button>
//     <SimpleModalSearch id={item.P_ID} />
//   </div>
// </div>
